import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicantService } from 'src/app/services/applicant.service';
import { CoApplicantService } from 'src/app/services/co-applicant.service';
import { LoaderService } from 'src/app/services/loader.service';
import { QuestionService } from 'src/app/services/question.service';
import { TosterService } from 'src/app/services/toster.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css'],
})
export class PreviewComponent implements OnInit {
  section_no: any = '';
  udata: any;
  questions: any;
  subsection: any;
  criteria: any;
  isLoaded: boolean = false;
  public model: any = {};
  modall: any = [];
  Sectionform!: FormGroup;
  secArr: { [key: string]: any[] } = { 'Applicant': [], 'Co-applicant': [] };
  btnDisabled: any = true;
  finalStatus: boolean = true;
  headers: any = {
    'Criteria 1': {
      A: 'General Regulatory Requirements',
      B: 'Food Safety Practices',
    },
    'Criteria 11': {
      A: 'Statutory, Regulatory and Social Compliance',
      B: 'Laboratory Management',
      C: 'Leadership and Best Practices in Laboratory Initiatives',
    },
    'Criteria 2A for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits',
    },
    'Criteria 2A Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits',
    },
    'Criteria 2B for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2B Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 4': {
      A: 'Social & Regulatory Requirement',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 5': [],
    'Criteria 7': {
      A: 'Self-Declaration',
      B4: 'Management of Partnerships',
    },
    'Criteria 9': {
      A: 'Statutory & Regulatory Requirements & Social Compliance',
      B1: 'Pre Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Good Manufacturing Practices (GMP)',
      D: 'Change Management Initiatives'
    },
  }

  constructor(
    private toast: TosterService,
    private _Activatedroute: ActivatedRoute,
    private quest: QuestionService,
    private applicat: ApplicantService,
    private fb: FormBuilder,
    private coapp: CoApplicantService,
    private loaderService: LoaderService,
    private route: Router
  ) { }
  ngOnInit(): void {
    this.loaderService.showLoading();
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    let email = this.udata.email;
    this.applicat
      .GetAdminApplicantSinglebyemail(email)
      .subscribe((data: any) => {
        if (data.applicanData.criteria != '') {
          this.coapp.listCoApplicant(data.applicanData._id).subscribe((resp: any) => {
            if (resp.result.length) {
              let criterias = resp.result.map((coapps: any) => {
                return coapps.co_criteria
              })
              this.criteria = [data.applicanData.criteria].concat(criterias)
              this.criteria = Array.from(new Set(this.criteria))
            } else {
              this.criteria = [data.applicanData.criteria]
            }
            this.quest
              .viewFinallyWithCriterias({
                email: this.udata.email,
                criterias: this.criteria,
                type: this.udata.role,
              })
              .subscribe(async (elem: any) => {
                this.finalStatus = elem.ass.length == 0 ? true : false;
                this.loaderService.hideLoading();
              });
            for (let [index, criteria] of this.criteria.entries()) {
              this.quest
                .viewQuestionSec({ criteria: criteria })
                .subscribe(async (item: any) => {
                  this.section_no = item.sections;
                  const sectionKeys = Object.keys(this.section_no);
                  sectionKeys.map(async (sec: any) => {
                    let no_of_field = 0;
                    let no_of_field_empty = 0;
                    this.quest.viewAssessment({
                      section_no: sec,
                      email: this.udata.email,
                      criteria: criteria,
                      type: this.udata.role,
                    }).subscribe((ele: any) => {
                      let arr = ele.ass[0]?.assessment[0];
                      let psh = 'Applicant';
                      if (index !== 0) {
                        psh = 'Co-applicant';
                      }
                      if (arr) {
                        for (var key in arr) {
                          if (!arr[key] || arr[key] == '') {
                            ++no_of_field_empty;
                          }
                        }
                        ++no_of_field;
                        let val = {
                          count: no_of_field,
                          emptycount: no_of_field_empty,
                          isreviewed: ele.ass[0]?.status,
                          section_no: sec,
                        };
                        if (no_of_field_empty || !ele.ass[0]?.status) {
                          this.btnDisabled = false
                        }
                        this.secArr[psh].push(val);
                      } else {
                        let val = {
                          count: undefined,
                          emptycount: undefined,
                          isreviewed: false,
                          section_no: sec,
                        };
                        this.secArr[psh].push(val)
                      }
                      this.secArr[psh].sort((a, b) => a.section_no.localeCompare(b.section_no));
                      this.loaderService.hideLoading();
                    });
                  });
                });
            }
            this.isLoaded = true;
          });
        } else {
          this.loaderService.hideLoading();
        }
      });
  }
  onsubmit() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to submit your application for review. Once submitted, you will not be able to make any changes.',
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, submit',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.loaderService.showLoading();
        this.quest.saveFinally({
          email: this.udata.email,
          criteria: this.criteria[0],
          type: this.udata.role,
        }).subscribe((ittem: any) => {
          if (ittem.statuscode == '200') {
            this.finalStatus = false;
            this.toast.showInfo('Finally Saved.');
          }
          else {
            this.toast.showError('Already Submitted.');
          }
          this.loaderService.hideLoading();
        });
      }
    })
  }
  goToSection(sectionName: string, index: number) {
    let rte = 'section'
    if (index !== 0) {
      rte = 'sectionco';
    }
    this.route.navigate([rte, sectionName, 1], { queryParams: { criteria: this.criteria[index] } })
  }

  getSectionName(section_no: string, index: number): string {
    if (this.headers[this.criteria[index]] && this.headers[this.criteria[index]][section_no]) {
      return this.headers[this.criteria[index]][section_no];
    }
    return `Section ${section_no}`;
  }
}
